import type { ScorecardCodeLanguage } from "../../../criterionConfig";
import { Field } from "../Layout/Field";
import { ScorecardCodeEditorField } from "../Inputs/ScorecardCodeEditorField";

interface CodeExecutionFieldProps {
  code: string;
  codeLanguage: ScorecardCodeLanguage;
  sourceTitles: string[];
  onCodeChange: (code: string) => void;
  onLanguageChange: (language: ScorecardCodeLanguage) => void;
}

export const CodeExecutionField = ({
  code,
  codeLanguage,
  sourceTitles,
  onCodeChange,
  onLanguageChange,
}: CodeExecutionFieldProps) => (
  <Field label="Code">
    <div className="space-y-2">
      <p className="text-xs text-muted-foreground">
        Runs against every visible column in the row. Access values through the `data` object by
        column name.
      </p>
      <ScorecardCodeEditorField
        code={code}
        codeLanguage={codeLanguage}
        sourceTitles={sourceTitles}
        onCodeChange={onCodeChange}
        onLanguageChange={onLanguageChange}
      />
    </div>
  </Field>
);
